export default __webpack_public_path__ + "static/media/logo_big.14a3dd87.png";